import { StakeActivityResponse } from '../../../queries/types';

export const getRewardsActivityModelCreator = (
  response: StakeActivityResponse
): StakeActivityResponse => response;
